import React from "react";
import styled from "styled-components";

const RowData = styled.div`
    font-size: 1.3rem;
    position: absolute;
    z-index: 1200;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: #0000002e;
    color: #ffffff;
    justify-content: center;
    align-items: center;
    display: flex;
`;

const Loading = (props) => {
    return (
        <RowData> {props.message || "loading..."}</RowData>
    )
};

export default Loading;